<template>
    <div>
        <Head title=" " />

        <div class="relative bg-white">
            <div class="flex items-center justify-between p-2 sm:p-6 md:justify-start md:space-x-10">
                <div>
                    <a href="#" class="flex">
                        <span class="sr-only">Throbo</span>
                        <img class="h-8 w-auto sm:h-14" src="/images/logo/throbo-logo.svg" alt="Throbo Logo" />
                    </a>
                </div>
                <!--<div class="-my-2 -mr-2 md:hidden">-->
                <!--    <button @click="isMenuOpen = !isMenuOpen" type="button" class="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" aria-expanded="false">-->
                <!--        <span class="sr-only">Open menu</span>-->
                <!--        &lt;!&ndash; Heroicon name: outline/bars-3 &ndash;&gt;-->
                <!--        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">-->
                <!--            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />-->
                <!--        </svg>-->
                <!--    </button>-->
                <!--</div>-->
                <div class="md:flex md:flex-1 md:items-center md:justify-between">
                    <nav class="hidden sm:flex space-x-10">
                        <div class="relative">
                            <!-- Item active: "text-gray-900", Item inactive: "text-gray-500" -->
                            <button type="button" class="text-gray-500 group inline-flex items-center rounded-md bg-white text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" aria-expanded="false">
                                <span></span>
                            </button>
                        </div>
                        <a href="#" class="text-base font-medium text-gray-500 hover:text-gray-900"></a>
                        <a href="#" class="text-base font-medium text-gray-500 hover:text-gray-900"></a>

                        <div class="relative">
                            <!-- Item active: "text-gray-900", Item inactive: "text-gray-500" -->
                            <button type="button" class="text-gray-500 group inline-flex items-center rounded-md bg-white text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" aria-expanded="false">
                                <span></span>
                                <!--
                                  Heroicon name: mini/chevron-down

                                  Item active: "text-gray-600", Item inactive: "text-gray-400"
                                -->
                                <!--<svg class="text-gray-400 ml-2 h-5 w-5 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
                                <!--    <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />-->
                                <!--</svg>-->
                            </button>
                        </div>
                    </nav>
                    <div class="flex items-center">
                        <a href="/login" class="text-base font-medium text-gray-500 hover:text-gray-900">Sign in</a>
                        <a href="/register" class="ml-8 inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700">Sign up</a>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div v-cloak v-if="showContent" class="flex flex-col flex-grow min-h-screen bg-gray-100">
                <div class="items-top relative flex flex-grow justify-center sm:items-center sm:pt-0">
                    <slot />
                </div>

                <footer class="flex items-center justify-between mb-5 px-4 h-16 text-gray-400 text-xs opacity-75 sm:px-6 lg:mb-0 lg:text-sm">
                    <div class="flex flex-col items-start lg:flex-row lg:items-center lg:space-x-4">
                        <span>&copy; {{ year }} {{ $page.props.companyName }}</span>
                        <span>All Rights Reserved.</span>
                    </div>
                    <div class="flex flex-col items-end lg:flex-row lg:items-center lg:space-x-4">
                        <Link :href="route('policies', { filename: 'terms-of-service' })" class="hover:text-blue-600">Terms of Service</Link>
                        <Link :href="route('policies', { filename: 'privacy-policy' })" class="hover:text-blue-600">Privacy Policy</Link>
                    </div>
                </footer>
            </div>
        </transition>

        <!-- Modal Portal -->
        <portal-target multiple name="modal" />
    </div>
</template>

<script>
import AppHead from "@/Components/AppHead"

export default {
    components: { AppHead },

    mounted() {
        this.showContent = true
    },

    computed: {
        year() {
            return moment().year()
        },
    },

    data() {
        return {
            showContent: false,
            isMenuOpen: false,
        }
    },
}
</script>

<style scoped>
.bg-gray-900 {
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--tw-bg-opacity));
}

@media (prefers-color-scheme: dark) {
    .dark\:bg-gray-800 {
        background-color: #2d3748;
        background-color: rgba(45, 55, 72, var(--tw-bg-opacity));
    }

    .bg-gray-900 {
        background-color: #1a202c;
        background-color: rgba(26, 32, 44, var(--tw-bg-opacity));
    }

    .dark\:border-gray-700 {
        border-color: #4a5568;
        border-color: rgba(74, 85, 104, var(--tw-border-opacity));
    }
}
</style>
